import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: () => import('../views/index.vue')
  },
  {
    path: '/downloadapp',
    name: 'downloadapp',
    meta: {
      title: '智慧CBRE下载页面'
    },
    component: () => import('../views/downloadapp.vue')
  },
  {
    path: '/downloadapp2',
    name: 'downloadapp2',
    meta: {
      title: 'CBRE管家下载页面'
    },
    component: () => import('../views/downloadapp2.vue')
  },
  {
    path: '/cbreaddress',
    name: 'cbreaddress',
    meta: {
      title: 'cbre项目相关地址'
    },
    component: () => import('../views/cbreaddress.vue')
  },
  {
    path: '/appTerms',
    name: 'appTerms',
    meta: {
      title: 'CBRE管家智能手机应用平台用户服务协议'
    },
    component: () => import('../views/legal/appTerms.vue')
  },
  {
    path: '/appServiceTerms',
    name: 'appServiceTerms',
    meta: {
      title: 'CBRE管家智能手机应用平台物业服务及生活服务须知'
    },
    component: () => import('../views/legal/appServiceTerms.vue')
  },
  {
    path: '/appPolicy',
    name: 'appPolicy',
    meta: {
      title: 'CBRE管家应用隐私声明'
    },
    component: () => import('../views/legal/appPolicy.vue')
  },
  {
    path: '/wisdomCbreTerms',
    name: 'wisdomCbreTerms',
    meta: {
      title: '智慧CBRE智能手机应用平台用户服务协议'
    },
    component: () => import('../views/legal/wisdomCbreTerms.vue')
  },
  {
    path: '/wisdomCbrePolicy',
    name: 'wisdomCbrePolicy',
    meta: {
      title: '智慧CBRE用户隐私政策'
    },
    component: () => import('../views/legal/wisdomCbrePolicy.vue')
  },
  {
    path: '/bonusQa',
    name: 'bonusQa',
    meta: {
      title: '积分常见问题'
    },
    component: () => import('../views/legal/bonusQa.vue')
  },
  {
    path: '/bonusTerms',
    name: 'bonusTerms',
    meta: {
      title: '积分兑换说明'
    },
    component: () => import('../views/legal/bonusTerms.vue')
  },
  {
    path: '/faq',
    name: 'faq',
    meta: {
      title: '物业常见问题'
    },
    component: () => import('../views/faq.vue')
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js